import http from './http.service';

class StaticRegisterService {
    constructor() {
        this.$http = http;
        this.baseUrl = "/api/dynamicRegistersAdministration";
    }

    getRegistersSource() {
        return this.$http.get(`${this.baseUrl}/getRegistersSource`);
    };

    getRegisterMembersSource() {
        return this.$http.get(`${this.baseUrl}/getRegisterMembersSource`);
    };

    create(model) {
        if (!model) {
            throw new Error('Model is required');
        }

        return this.$http.post(`${this.baseUrl}/createStaticRegisterForDropDown`, model);
    }

    update(model) {
        if (!model) {
            throw new Error('Model is required');
        }

        return this.$http.put(`${this.baseUrl}/updateStaticRegisterForDropDown`, model);
    }

    activate(id) {
        if (!id) {
            throw new Error('Id is required');
        }

        return this.$http.delete(`${this.baseUrl}/activateStaticRegisterForDropDown`, { params: { id: id } });
    }

    deactivate(id) {
        if (!id) {
            throw new Error('Id is required');
        }

        return this.$http.delete(`${this.baseUrl}/deactivateStaticRegisterForDropDown`, { params: { id: id } });
    }
}

export default new StaticRegisterService();
